import React, { useEffect, useRef, useState } from 'react'
import { StyledForm, SubmitButtonWrapper, TagsWrapper } from './style';
import { Button, Checkbox, Col, Input, message, Row, Upload, UploadProps } from 'antd';
import { _FORM_ITEM_LAYOUT, _TAIL_FORM_ITEM_LAYOUT } from '../../../constants';
import Tiptap from '../../Common/Form/Tiptap';
import { UploadOutlined } from '@ant-design/icons';
import { TreatmentAdviceType } from '../../../types';
import { useParams } from 'react-router-dom';
import { useGetProfessionalClient } from '../../../hooks/professionals/useProfessionalClient';
import { useCreateTreatmentAdvice, useUpdateTreatmentAdvice } from '../../../hooks/professionals/useTreatmentAdvice';

interface TreatmentAdviceFormProps {
  type?: 'new' | 'edit'
  defaultValues?: Partial<TreatmentAdviceType>
  onReset?: boolean
}
const TreatmentAdviceForm: React.FC<TreatmentAdviceFormProps> = ({
  type,
  defaultValues,
  onReset
}) => {
  const { clientId } = useParams();
  const tiptapRef = useRef<{ clearContent: () => void }>(null);
  const [form] = StyledForm.useForm();
  const { create: createTreatmentAdvice, loading: loadingCreateTreatmentAdvice } = useCreateTreatmentAdvice();
  const { update: updateTreatmentAdvice, loading: loadingUpdateTreatmentAdvice } = useUpdateTreatmentAdvice();
  const { refetch: refetchProfessionalClient } = useGetProfessionalClient(clientId as string);
  const [description, setDescription] = useState<string>(type === 'edit' ? defaultValues?.content! : '');
  console.log('defaultValues', defaultValues);
  // const props: UploadProps = {
  //   name: 'attachments',
  //   multiple: true,
  //   onChange(info) {
  //     if (info.file.status !== 'uploading') {
  //       console.log(info.file, info.fileList);
  //     }
  //     if (info.file.status === 'done') {
  //       message.success(`${info.file.name} file uploaded successfully`);
  //     } else if (info.file.status === 'error') {
  //       message.error(`${info.file.name} file upload failed.`);
  //     }
  //   },
  //   beforeUpload: (file, fileList) => {
  //     return false;
  //   },
  //   defaultFileList: defaultValues?.attachmentUrls ? defaultValues.attachmentUrls.map((attachment: any, index: number) => ({
  //     uid: String(index + 1),
  //     name: attachment.split('/').pop(),
  //     status: 'done',
  //     url: attachment
  //   })) : []
  // };

  const onChangeDescription = (value: string) => {
    setDescription(value);
  };

  const onFinish = async (values: any) => {
    if (type === 'edit') {
      console.log('onFinish', values);
      try {
        const res = await updateTreatmentAdvice({
          ...values,
        });
        console.log('UpdateHealthComplaintForm', res);
      } catch (err) {
        console.error(err);
      } finally {
        refetchProfessionalClient();
      }
      return;
    }
    try {
      const res = await createTreatmentAdvice({
        ...values,
        clientId
      });
      console.log('NewHealthComplaintNotesForm', res);
    } catch (err) {
      console.error(err);
    } finally {
      refetchProfessionalClient();
    }
  };

  const handleClear = () => {
    tiptapRef.current?.clearContent();
  };

  useEffect(() => {
    if (type === 'new') {
      handleClear();
      return;
    }
    onChangeDescription(defaultValues?.content as string)
  }, [type, defaultValues]);

  useEffect(() => {
    if (!onReset) {
      form.resetFields();
    }
  }, [onReset, form]);

  return (
    <StyledForm
      {..._FORM_ITEM_LAYOUT}
      form={form}
      name="treatment_advice_form"
      onFinish={onFinish}
      initialValues={{ ...defaultValues }}
      layout="vertical"
      scrollToFirstError
    >
      <StyledForm.Item hidden name='id'>
        <Input />
      </StyledForm.Item>
      <StyledForm.Item
        labelAlign="left"
        name="content"
        label=""
        rules={[
          {
            required: true,
            message: 'Content can\'t be blank',
          },
        ]}
      >
        <Tiptap
          ref={tiptapRef}
          content={description}
          onChange={onChangeDescription}
        />
      </StyledForm.Item>
      {/* <StyledForm.Item labelAlign="left" label="" name="attachments"  >
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </StyledForm.Item> */}
      <StyledForm.Item>
        <SubmitButtonWrapper>
          <Button type="primary" htmlType="submit" loading={loadingCreateTreatmentAdvice || loadingUpdateTreatmentAdvice}>
            {type === 'edit' ? 'Update' : 'Save'}
          </Button>
        </SubmitButtonWrapper>
      </StyledForm.Item>
    </StyledForm>
  )
}

export default TreatmentAdviceForm